<template>
  <div class="person">
    <div class="topContent">
      <div class="topArea"
          style="background-image: url(&quot;/static/img/xtb/bj.jpg&quot;);">
          <div class="head_area">
              <div class="leftImg"><img src="/static/img/logo_icon.8abe279d.png"
                      class="top_back"></div><span class="head_text">我的</span><a target="_blank"
                  href="https://regtg.xrswtb.com/index/download?pid=0" class="right_menu"><img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAEbUlEQVRYhd2ZW2hcRRjHf3tJkyZq24RaUWprpDSmNSlqVLQ1atUq0np5Uak+KFIffIkPgggWH00RRF9UREFaRXwRfRCsl5KCCE0Fa6n18mCSJkaizd7aZnfPZeQ7M6d7sjXJZmeTrP5hOHuSnPl++fY/38yZiSmlqFCtwC6gB+gG1gErKn24TBlgGDgGDAKfAZMVPSnAc7QupdQ7SqmcWjjlTIyuuXjmgu1fQMiZ1F8N8NVKqcElgA11xDBcwPZvHr4WOAS0VenPWuk0cAdwPNpfOfAVwAmLwVRryeDcDIyG/cbLAhysI1gMyxfRH0SBXwE6F59pTnUatkChJdYDv9chbFRXAUNhhvfWB9OsChglwyuBv4CkTW/jUzCRh0QwGenm++D54Cu4fg3EY1bALrBaIHfawh6egHd/BdcF5YHjguPoa7EIk2dhy2p4dTusWl51GGHcJZbotYEVDfwJmQIsk6/MM83XLe5DSwy++Q2+H7ONRK9Qb7LtJaGgwdc2wNdNoIMv0dw3xcCreJ01ozYJ8FrbXgIbiAXi2hbBZ9PkvmiudhYOdLkAX2Lbi+ca38Yj/nVKn11HQyvfGvhiAbb+x11PAzXGNKRbBlw09769JZICbN2NADtFKCaMBdzpmQ5t4ttnWFmVs/PAxqeOmu7fadl2pOjbx6oJsJSvQhGalM60G8K6pezmi7CyeZGBf07DwCgkY2YA+doOQyntXzesCp6BNZmVKnJREl7/Gr68DLJ5/fzZc3BlGzy3A5qXLQDwB7/A/pOwvllnTLIqQKsaoAEoOKWqEFzNrCdwTUn4+AhwxowaqdE5fX97B9y6YQGAH9sAx8YhdQ4ubYSClLGEhisY0LBFLRE0D1pbwG3U64vA8znY/QRct65yhvIF/KzqbIV92/R0O5YGX0CKJSucL2VeBNQBzyvVaj+EPQWP7IQDz8DyCu0wb2BRRxu8cTf4HoymdLacsEpEylkI7EXgxRpByRuBB3fAR8/ON3oVwKLuNfDm/RpyLKXhJdNhGSu3glzlbyTzxRG4bzt80ldN5CqBRTevhfcehqk8jE0a6JlgfQ1bGIY7b4PPn682qgauemrubYf3H4XsFIyndfkKB13oW9+UPsns1lvg4AvVwwpr3HZqvrcDPnwcsmdgIq2XmG4UViaVEejpga9ehITlW4cAZ626AB7qhgNPwlQOJjM6BTIYZf0rNujaAodegsaEbSRy8egmhY123whvPw1OCjJZkPV7fhg2bobDe6GloRZR+CNudnpqoj1b4bU9oP6G/I/QvhG+fRlWNNUqAidkphsAnqpVj3136XL33VF4qw/aarDgiWigZq/5i6DgNV8skQb21zkshjH9X9qqahfGcKYbAvqXGGg27QsTWr4//BNwTZ3BnozuqpavJe4xm8j1ooxhYiZgmUS2me36pdZpwzI6GzDmTOEm4OgSAg8ahuMX/Ob/cuwVbXV1sDjfo9sHgBvM0a3U7mr25WSDQFaIp4AfjPU+rejoFvgHLgpS2a1fhHAAAAAASUVORK5CYII="
                      alt="" class="right_menu_img"></a>
          </div>
          <div class="part1">
              <div class="avatarBox"><img
                      @click="go('/userInfo')"
                      :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/logo2.png'"
                      onerror="this.src=&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAMAAAAd31JXAAAA3lBMVEXx8fFPj/9Qjf/KysrOzs7z8/Pm5ub5+fr29vb39/f4+Pnv7+/r6+tXkv9TkP/z9v3u7u7d3d3R0dFVkv/s8f2xy/9el/9alf/7+/uEr/9+q/9onf9kmv/19/rT09PP3v+90f+Ntf+CrP93pv/i6v7T4f78/f3h4eGmxP+jwv+Suf+Isf9gmP/+/v7m7f7K2P74+vzZ2dnV1dXD1f+sx/96qP9zpP9vof9sn//f6P7f39+2zv+ewP+bvf+WuP+Lsv/a5f7Y4v7a5P3o6OjX19e30P/o7v7K2/7v8/zj4+N7hHehAAACO0lEQVQ4y4XV53qiQBQG4GERZkDpXQiCBevae4luNJvk/m8oEQVmFOP3+30OhzMN/CEiLMrdTsvYGNvQmbkaRQS3olfdDlaSDePob0GnZuZbsdfd1CGPGBCHQRyUGq2alWO12rQPY5iF4aXGzr2zQlgZokxlWn+fa6S1XvuQAXlBLx+OhVthp/PgQZiXhqNlVuvoHAlIXCmnVqz2yarFYpHEk0Vi3QrEYampKGsW1+hz2rtYoT1kMMqOCzRN+00ccyvnYhf/8WZLPh1H/SK62HhnK7QivIM1fc1Jxruo78/WrBNlx4lVWaKwYVJA7EYMbtXEFpoAC9eYUUAIbJBv18Ty6R0KWCuOsH7aQ5OccVsE1pDYB7KSWL8E8PDvHlhG5JKxhWsLShHg4So14PwFIK/wuARI+68MXm8sOKrZFLCgt+q9LY2wbknbzbdj+db+9LAkbfGoFC6/drz/NxOfmcyO/GQO/ojFa/OBB6xsO8hfJ5XGoo6aqWb4lgaECUw3biIzfWITe15jcR8x2WDvomTj/dmT3nWry+tCThLLG+Z5rxvR9ZyxObmOGfXD+AzNdQSehOEDN7bC1GaeWFQPxcuZXx7gk7LS1EzvEp37vYOPeXpHCTsJ/UYbVS27+3otiXtMD3sBv1O99if/sGrXIu9qM1zZeX1w0qQs3L0Bs0CCtxrBetvVct4WzxlINsekH0dw2Ddm5oM3yy0bBymyIeQhtG29sp33RIqwuO4ta6ExGQwGQdtZuBZF5Bt7fzdTiJun1QAAAABJRU5ErkJggg==&quot;"
                      alt="" class="avatar"></div><span class="signature">暂未设置签名</span>
          </div><img src="/static/img/hudu.26088fcf.png" alt="" class="hudu">
          <div class="part2"><span class="nickname">{{ $store.state.userInfo.username }}</span>
              <div class="rightSpan"><span class="username">{{ $store.state.userInfo.username }}</span></div>
          </div>
      </div>
      <div class="topAmount">
          <div class="AmountLeft"><img
                  src=""
                  alt=""><span class="AmountName">账户总资产</span></div>
          <div class="AmountRight"><span class="AmountMoney">￥{{ $store.state.userInfo.balance }}</span><img
            @click="$parent.getUserInfoShowLoding()"      
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAXVBMVEUAAACpsMqpsMquuNKqscqrssupsMqosMqpsMqosMqpsMqpsMqpsMqpsMqqsMuqscuoscupscqoscuor8ioscqpssinsc2psMqqsMmqsMqpsMupsMmosMmmscipsMrAnmk1AAAAHnRSTlMA86cHwyiwhGtB+Orj29K3no9ZRjccFNXIvHp3Xi6KZiMMAAAA2klEQVQoz42SRxLDIAxFRTC49x7b3P+Y+UAYYIaF/0roqSEgp3k8alZ3w80pVpkpp6aISK5CZcITqSAm829uk9kM56JJj1N1bSbqGQxc1l7h9IHZCd+20ZFMARWw9mis01YlEsjaQrJKh5A3BYAj0iPoFbIdPErsBqgdeQJOLYZXqp0SjI8tMb20klICgj4ijSzk79BUeCTXMHzTHRw6o+l2eJCHu1WwGj+k6HR9AurXxSQOjy126cie/u8826oZfoA0pgw2mqlQOYUqGutN7YbfQ4c/eoyz8/wAG0gaU4TQX6QAAAAASUVORK5CYII="
                  alt=""></div>
      </div>
  
      <div class="actionList1">
        
          <div @click="go('/vip2')" class="actionicon1"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/viptq.png">
              <div class="title"></div>
          </div>
          <div @click="go('/applyagent')" class="actionicon1"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/yqhy.png">
              <div class="title"></div>
          </div>
         
      </div>
      <div class="actionList">
          <div @click="go('/account')" class="actionicon"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/qb.png">
              <div class="title">我的钱包</div>
          </div>
          <div @click="go('/transRecord')" class="actionicon"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/mx.png">
              <div class="title">账户明细</div>
          </div>
          <div @click="go('/betRecord')" class="actionicon"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/jl.png">
              <div class="title">投注记录</div>
          </div>
          <div @click="go('/userCent')" class="actionicon"><img src="http://imgtc.qp79799.top/TG@msdj123/wd/aq.png">
              <div class="title">安全设置</div>
          </div>
      </div>
      
  </div>

  <div class="refresh">
    <div class="refreshinner">
        <div class="person-list">
            <div class="person-list-p" @click="go('/iframepage')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABRFBMVEUAAABXb6pyiLxHY6Qwg/90iccoiP8wgv8wg/9Vb6xkfLRierNfeLFcda9Zcq5EjOdSbaowg/8wg/9JaKdSc61nfrUvg/9yh7psg7lXcaxJZKVqgrdOaahHY6RyibxJZKVvhrowhP9LZ6ZLZKYvgP8yg/9beLFtf7ZJZKRogLYwg/8wgv8wg/9vhLgygv9xiLtIZKRRbKkwg/8wg/9zibxpgbdQa6huhbkvg/9LZaVvhrpuhbpKZqVuhbkxg/9OaadGZKRwhrxHY6Qwg/9wh7pIY6Mwg/9HY6Vxibxrgrdwhrowg/9yhbhLZqUwg/9tg7lNaKgyhv9tg7Ywg/9yibtyibswhf8tgv8rgP8wg/9xiLtHY6RKZaVvhrppgbdMZ6ZlfLRthLhddrBRbKlPaqhuhblgebJZc65Vb6xOaadXcaxTbqsQG82JAAAAWXRSTlMADfLygAwMNfLy8vLy8vIG9OJBJwryvyf+8t65uLOyqXx5WiMcGBgODvXTr5glI/X18e7p39/f3dnU08DArIh8e3Z2aWRkXV1cWlhQQUE6NDQpI7mopkstEtAfny4AAAIRSURBVDjLldJZW+IwFAbgwwwDg6CVVgTZBdlE3Pd93/dZw5QUpDgy8//vPUlbwJZS/W7yJXmftslT0CPtJ6KfLYkm9iXoTTb1xzapbNedzfMl6xP58vyZ4Q5xJidOpKLLlKJ0kpBx81BzGVmWN27AJjcbuJ1hLY9lewxsM7aNII8lpShRGJiooqTwwIqi3A+G90iysNdux8Eh8XZ7D+KqmnGCGVWNw6ralJyg1FRXYbQ5WuQz0e12T/WHRUQIF7S7mSGEiDY3tIDQ99/n4jM3Qm9/6EIEvpf3wJcPwIl/EyaYE2/FHLB4RXGWQ0Qw8nfEBGexjBvlJ4eI+kAYx8YuapKQJejA4adhM7zCdoTjNCG7GkTUD8Iif/cDLvzqwsBTwAz53efYwjRoEBEEnq3Qi/WUvXlSh4jA/+y3QFgnZCbHjqRDROCv98AH3vh518vsQ3WICIbqQ114C4IgeACmCM+RARG9hUtBzGKZXyXmdy8M1UPab7ZLjAQBTtlY7vxmiKBESwXtu74a+QbgCeJ4ZcBCiYZghdIKnwmeTvQZGKlQugIxSi/AIReUxiAdicScYCwSScNjo9G4G+zukDwC7LRaa4PhWqu1g0O+VqttCfZM2EKQZ+0Sy+a1nbvexO1LrR9UMcnjcOGLKYXwcZLtHYCe87kqyydL+PLcOXRS+VG1zfcw9CacTi5bn7icTBvsFXD/k2AsVt5oAAAAAElFTkSuQmCC"
                        alt=""><span>我的等级</span></div>
                <div class="person-list-p-right"><span class="level_img"></span><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p" @click="go('/vip2')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABYlBMVEUAAAAwg/8nif9GYqNKZaVIZKRgeLFdeLJdfbRTbaplfLNnfrVIYqJme7RPZ6g5gP8shv9LZqZnfrVuhblIZKRKZ6ZthLlOaadPbKlkfLNhfLNie7Rie7RzibxkfLQwg/8wg/9gebJfd7Fof7ZqgrhWcKxddrBshLhOaahwh7pyiLxKZaVyiLxVb6xwh7tZdK5NaKhvhrtuhblbdK5bdK9rhLlcdrAwgv9wh7pOaahdeLEuhP9geLBof7hsg7dNaKZWcKxOaadnfrVWb6xhebJqgbdIZKRHY6RogLdYcq1GYqRMaadddrFFYqNSbKpcda9JZaZuhLlUbqtOaadUbatJZaVHYqRQaqhwh7pQa6lwh7tYcq1IZKJpgbdkfLVqhLlHY6Qwg/9xh7tthLlqgrhnf7ZhebNZc65OaahLZ6dUbqtwhrpvhrplfbReeLFddq9cda9SbKpQa6hKZqVjfLRWcKzmHSLRAAAAYHRSTlMA8g3yHPokDQjsNCkYFRIJBfX0yLpnUlJDPxz79fLu7ejo4eDa2dfSy721o52WiH59fHJyamhfXFxYVExKSS4r+/v69+/p6ejl39/Z0MrGwr+zrqqhl5STkI+Egm5fPR1PYWbBAAABvUlEQVQ4y82TZ1PCQBCGF42EbkFRsffeG1LtvfcuCql0Ev6/61wGEpLAV54Pye67z93cTSbQAHxcNus5e6Kqvc64MccxrTf3H7bowPCIVnvdmDxaXZQWl6tLisc7VZ6nXZJuwIguSZKWVQcUhHYPGDInCEJPeRk222DCOW7iIiXF8/w9mEHt8vw0Kad53m4jZWuTilblorjPMyDLxWJROcXWkEXFcIikryjgyWKFQmGBJG0/WixtJL9ChYI7UZwARbRUmYrosYviA+CjfP3QsEXF0Fb5e4iiHfZLJQ/W5pdB6FJpByY4bgHq8M5xp7DGcdxSbW+dKNf5fH6tlreJwqQNwHaRy+XWzb0gjkfdgNCT2Wx208wL43DET2r3KMuyQWOvF0cHVlDwj2AbNvIcfSzb76z01kFZlnv1nrNflvscmqQjk8loErIe06r1jj2G6YhqM/8JwzARqOKLQdOqTtxjGPlARySZTB5+V3p6HINPMMCHgzE3KNimsN0AQwKJRGKcBoIXm1UwYQOHU+T3mcFyBUxZTafTXkBusViEGqykUilv1DmLrxeoyduvwjzUYVHnmeGbHRiYCUAD8Qd6nHeDKeVnIAAAAABJRU5ErkJggg=="
                        alt=""><span>VIP中心</span></div>
                <div class="person-list-p-right"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
           <div class="person-list-p" @click="go('/inviter')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABKVBMVEX4+fz///+zv9r////6+/3c4u6uutj///9rgrc7WqA+XKFCX6OhsNFFYqWIm8Wqt9Zed7Dm6vROaqlogLZherJXca5Sbavz9flUb6xKZ6dJZqZHZKYwg//j6PLN1edddrD3+f76+/3g5fC6xd6drM+bqs9mfbRSmP8Gav/q7fXH0OSgr9GLnceEl8NcdrBQa6pNaaiHuP8JbP/p7fSks9OYqM2Pocng7f/a6f9bnf9LlP9Djv8pgP/v8ffp7PTW3euottWSpMp/k8F4jb12i7xvhrk3V53m8P/k7/+hx/+Dtf94r/9hof86iv8dd/8Zdf8AXv/8/f7c4u7AyuG+yN+1wNuuu9ifrtB7kL8iRZS/2f+Wv/9opf8fef8Ob/8AVf8AT//s7/Wyvtpga9s5AAAAB3RSTlPy8vLm8vLy/EbT0gAAAf5JREFUOMvtlWlT2kAYgBdRN2xcoNnc4UYIIkKgQMshIFfVelartXf7/39EN4dZxiDwA/p8SWb2mWfyvjM7AeGQxzZYxvNpGECXbIEjXJDiNOUJIOQ8bscRC/NBdIMvO0LIE++RJB1Voi+pzFSNZBfFFi/fwyUoE01KLooFJGbhMmKomlsU95H4h51m2Osen06+EA987eLqqy8erhDfX9983Eh8lyidbyR+SJTqr4otVB04tQuzYyb6vU6ne+atQ2JT08U8PqnHkFL/3Wj8TFz+KDVurjPO1E+CQgVbVNokmoOjlDuI2TO7if6l2e19czcey2UKxcmQipW5gNXP8Jlbe5g6ZOQIL/DCDgCiJAky/pKDS4dRTgxBFkS0CwDBzUNc09WYv8d+w99juYglPL3j0BYA3DwP81VMo5/cw9OrX+csJxjtLIw7YmQE4dsjo6bLXvTs+ynLFcsQJtOuaJ+70Ykd9Thu05x+otDXN3Em2lFc0+SR/3UiVjGhSwuITlTF06GTqxiCpbcyMCCyqFpIDR/sr+PsXFD0ommsarKky5ZWsHNBkUU1XtcwP3NzQZGRao3H7TyEK0XGf9EXHzYTyfzvOlERI1tgmxjcYI14J6Bdegv5Gnls7r1Oc1+0rB0QOojzOoqsAmHUDAEIB1FCuFWQGb32zu8DrIEq4X9Nol0/980wZwAAAABJRU5ErkJggg=="
                        alt=""><span>邀请好友</span></div>
                <div class="person-list-p-right"><span class="textRight">推荐送礼金</span><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p" @click="go('/message')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAA7VBMVEUAAAAwg/8nif9Saqdqf7NIY6ROaadedaxRbKladK5Ycq1JZKRrg7hXcaxpgLdyiLtQa6hhebBObalhgLFwh7tierJeeLFcda8vgv9cdbAwg/9xh7thebNTY6FJZaVSbKlNaKZJZKRZc65Vb6tLZqVWb6xKZaVuhbpke7RTbqpMZqZHZKRWcKtKZqZwhrtIYqRogbZTbaxMZ6ZGYadthLUrgP9whrpthLhnfrVXcaxnfrVfeLFvhbpkfLRyiLtlfbMwg/9Ycq1IZKRVb6xLZqVxh7tgebJRbKlNaadje7Rvhbpsg7hlfbRuhblogLb9ZpIWAAAAQHRSTlMA8g0NDfLzCPPyWVfz8/Py8h0WD/Pz8s2Hh4ZZVxD9+fj08d7e19fV1dPTzYmJiIdNTU0dFgj9+fj18vDe3s2JA1tJ9AAAAZdJREFUOMulkulSwjAURqMtoBRZVcSyr2UrWwVkFROE1tb3fxyTlGmDc8sM4/mVe+bLzYquYjLohjjdweSSU0KfHiHlgmNFhU2usJES5NJFQppKQaIUlCYhxTTsUJ+QuoROSHVC+rBDHULGyGNMSAd2KHwsS76Uyscw6JgMR3wZoSXouBRnMwk6lDwkRUlL2KG7w524DC1Bx2RJnF2iEnSojfHIlyOM27BDPYxr/uXWMO7BDqUxxo1ohj9XtEGLNOgo0R3lgfHORlHYcVvdeVRhdyKVy95zsrkU7C4jSxQZXQ9f5pkjLHN7huvyyy+PZd51LzdnvPIcCzxx2Ign3z7+QJ1hmqaWz8iUTF6jhRHQcWuaa+9ombVpbgP2qNn2EHkMbVtDMAt7Lgt3N7cXEbhj/CcuflJaytAeeVDsyEr41LHvmBikJdiRB8WlWRDYIw/OxI4zNg+k5Tji9ThOK+AedctayV7DlWXpAS9jTC2rpbpPqLYsa2qAb01R95RHDhup8O/hycTeI6HC/9ElpW8SnI2eQv/lFwLhamNy0McEAAAAAElFTkSuQmCC"
                        alt=""><span>官方公告</span></div>
                <div class="person-list-p-right"><span class="textRight">邀请好友，坐收盈利</span><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p" @click="go('/applyagent')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAB11BMVEUAAABRba5LZ6YzhPsrhP8wgv9lfrNderBTba1TbapHY6RfeLJGYqNHYqRddrBHY6RKZqZkfLRJZaRKZaVPaKdfdbNHYqdCgMBddq9Zc65Ra6lsg7hlfLRJZaVrgbduhblkfLRxh7pQaqhwhrxfdKlccKdhd7JHZKVrf7FxiLted7FzibxRa6lIZKNVb6tbc65IY6Rje7RiebNJZaVeeLJGYqNvhrpshLlUbqtHY6RcdbBJZKVqgrhIZKRbdbBWcK1vhrpOaKdogbdkd6lierNGYaNIZaZPaahddrFVbqtGYqNNaKhYcqxZca1Zcq5LZ6hKZqVQaqlHY6RQaqhOaKdherNIY6VogLdbdLFpgLhshblwiLtjcZ5YcKxRaqtugK9RZ6gtg/9xh7tVb6tVb6tVb6snhf9lfbRSbKorhP9WcK1Wb6xkea9fd69pf7Zzibtcda5zibxZca1Sbqothf9Pa6lNaalLZ6hJZKVeebEwg/9ada8vg/8gh/9edbIyg/9deK4vhP9lc59IZKRcda8wg/9KZqZHY6RkfLROaahrg7hxh7tZc65nfrVUbqtierNhebJMZ6deeLFwhrpvhrpuhLlqgbdogLZYcq1WcKxSbKpRa6hdeLL5udIPAAAAg3RSTlMABvYKz2UaDwr29vHx4LKFcl9QSSkUEgT699q7uJJdWllWS0MwJiMbDPf38vLq6Obk39ra19PSzs7OzMzJyMfCv7y5uLWyr66kpJqWk46Eg3Z0cmtkYlZTUU5KPDw6LSsXE/Hs5OPh19PLyb69tbKxrqeenJKRi356cmtpYVdMSEI8NUGTfcIAAAJeSURBVDjLzc7nW9NQFMfxX4uWTilQWkBwIHvvIbJEhmwREUUZ7r33VtKYQJq2YXX4x3qapOS2PA+81O+L3pNzP09S/PMqZodcTmfbWI6xyhlrczpdQ7MVrMuy/9brytU2uV3JjT3LeF33GmVvrFtLpO6z1LGu0Z44elY053XRw/C812T1uFtoLAaK6Whxe6wm7/wwjS6vCrt53lwCLdM4z/MzH+in2JT8r2ae7wE1Q86DvaZ5tffGZomkG6g0h8O5YHKHqWl2kxMOm62YE8UBsF0WRfEdUhoQxTmMiGLKCy+Re4vUSkRxBIXxWivr4vH4OKjvP41lpi1eCFvsAfvdWCz2GtQnv/+osS6M1cImdzLfkGX5ojq98bOyU7ahXq5HMt+dpMPqEUb6bst30ReNLkHvZjT6KDlnMLI0Gn2MqUhkEnoLkchEwr/qmyhj5WQkMgWPJBXk6bBMkhpKTZ8lquCGJr/QeqVAksqAYxzXC71ejuMaOC1drgJnOe4FXVryOe6YDssdqhn9QXf5v5Dx0H8PeEqz+s0FRVH25KijuvUjkNmqKNWl8H3NwOAfRfkGtSuhUEiXRPK0ozkUcizTMEiX2YAug8HgBaSW1xQMOix4QlenjG22IAjp0tIkCM1FdEGOkQFBKEqX9wUqQC5VBgLpsjxAXUVaJ3Z3d8+DzfeMVuT2yZ2dHVaaztHiGg375fr6+nHG0SPj2E4y0tpBD9fBxsrt7W1NVnbQaLj9cmtrqz/h2mk4gwM6vbm52Z9paaeD3IFyY2PjVhX9kDtUUlWLOLTF5zU1L5fxH/UXdonN4Es54NEAAAAASUVORK5CYII="
                        alt=""><span>合营计划</span></div>
                <div class="person-list-p-right"><span class="textRight">加入我们，月入百万</span><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p">
                <div class="person-list-p-left"><img
                        src="/static/img/enter.03a1069b.png"
                        alt=""><span>NG扑克</span></div>
                <div class="person-list-p-right"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p" @click="go('/activity')">
                <div class="person-list-p-left"><img
                        src= "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABwlBMVEUAAABVd7Ywg/9qgbdWb6lrhLpSbKpyibxXcaxPaadwhrtRbKlTbqpwh7tuhLpthLhXcaxJZKQzf/9PZrBvhrpvhbtZcq5wh7tje7Rpgbdvhbpsg7gsg/9shblqgLZZcq5shLlXbatTbaxLZ6ZPaqhZc65VbqpvhbhpgbdUbqtGYqNQaqhYca5Tbapwh7tIY6VRbKpfeLFKZKZsg7hbdbBthLlKZaVzibxthLlWbqlVcKxwiLxshLlUbqtUbKlogbZmf7ZzirxvhrpngLZWb6xLZ6ZIZKVgerJngLZTbqpthblierRZcq9thbpOaqcxg/8shf9feLJRbasuhP9PaKQwg/81hP9ogLZwhrtrgbdgeLJcda8wg/9je7NgebNherJbdK9xiLtddrBNaKdNaKcwg/9rgbdacq1ngLVvhrowhP9fd7JmfrUwg/9RbKlRa6hbc7Avhf9ddbFqgbhZcK1LZ6VLZacvg/9gebNddLBPZ6pRaqhheKxVb6swg/9thLlTbatxiLtwhrtvhrpsg7hIZKRgebJYca1NaadLZqZddq9mfrVPaqhadK5SbKpje7NJZaVkfLRfd7FqgbdogLZed7Hrmgn7AAAAfXRSTlMABtJRORT58+W3lIJcODAnIhwNC/auqqino4ZrUUk/LR0bFvn18e3r5d7e2tnUzcvJwsK/ura2tLKwpp+bm5KNhH19e3Z2bWloZmNeWlhYTUtEMiwTEgn7+vn59uvm5t/b2tHR0MzLysi/n56YjouKh318c2RjYmFQNyopEfJizlAAAAI6SURBVDjLpZFne9JQGIYPlr0rIAUslO69d+0edmtrrXvvvbcQbULIBAr0/3pOEgqeBIqX9wfyvE/uizMC/oPazs7aqsS+RKKvGm8lAVmpYuEEInPy4oOZzOhoJjN4kveJZVmdDv58ruztNbHsMgDLLNu0V1G0MMxD9HzAMJZK3jbDMD9Q+A7DdnnP0ywINjnaBKHZU85rtAhCV2HoEgRLo4YUtb/uN6ZSqd1CsQsHY/8be7REcq/N9Bh/SdiKrU1ujD0za24066c7YnCOQVon7KAE+0QratHLjmk9iMmYJ5f0HtXh9EuTZkUA3clkcngzogNl0EU+noFKN4iak8kncnfxnbYOxRY3PEqLKJrRRVyKxx/ta3miKOpRiNzgxLs/JTF+6rTKeyty3KYcv3Ecdx+uelbLPA9fvi8MO9ns0QDQNHeOstkXxfErTdPDWqbrOk0PgBI2oFkHnxeQefm4Ntym6Tu6v7eSTqfDinnz2JxLp281YJuuOzxclS4zHn++X1JuAIwAz9dI4curYvkSlRhPed4JcGZ5PoR37fkrBpW4mM8vYpXhWq4dqPiQy81hlZOiHiuxJhAobGyVomYxsZ6ixuUwREGG6qVhi6LOYeI6QaAqPEIojITRnxOEHxMXCGIdOHzQINtCoTYSBp8DuAhiHBOtJLkQJCHeoAEeLehF2brlJZ9hou9Axqp8sQarNF496MXE3t+IKVexcU1J1T1MNMHO78SuzA9LEybOm8YcQIVjzDQP/pE/01K0Z1nZ3FQAAAAASUVORK5CYII="
                        alt=""><span>活动中心</span></div>
                <div class="person-list-p-right"><span class="textRight">平台优惠回馈活动</span><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
            </div>
            <div class="person-list-p" @click="go('/userCent')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAACDVBMVEUAAABIZKRQfbZJZqduhbpJZaZkfLQwg/9yiLtcdq9KZqUwhP8vg/9Qa6lthLlNaKZgerIygP9xhLtfda1xh7tyiLwwg/8vg/8wg/8wgv9xh7tvhrpPa6hqgrhqgLdrg7hMaKZherIwg/9tgrhZc64vgv9uhbkwhP8wg/9wiLtvir1KY6Uwg/9xh7swg/9GY6NXcaxHY6RSbKlGY6NMZqZmfrZOaahQaqlyibxIZKUwg/9pgbdqg7dxiLtgeLEwhP9XcK1sg7hMaKZkfLVKZKZMaKYwg/9Vb6ted7FOaahvhblJZaQwg/9IZKRuhLlMZqUwhP8wg/9qg7hSbqxOaKYvgv9MaKdWcKxXcKtfd7Evg/9nf7cwg/8vg/9me7RIZaRqgLgwgv9uiLtQbKowg/9hebNhebJuhbkwg/8wg/9LZqZvhrpogLYwg/9rgrhGY6NRbKlGY6NOaqdZcq4wg/9rgrdTb6plfrROaqcwg/9kfLMwg/9thbkwg/9ada5bdK5vhbpLZqdMZqZzirwxgv9Ycq4xg/9xiLpsg7ZXcq0wgv9MaKVie7NrgrhQbKhOZ6ZNaaRRaKhTbKZogLdEZqEvhP8wg/9thLhrgrhLZqZOaadNaKZHY6RuhbpxiLtpgLdje7RVcKxyiLtcda9Yca1SbKlQa6lwhrpnfrVlfbRhebJgebFed7FadK5TbquF1h/vAAAAlnRSTlMA/gYjqZxw/Oe4s5iThF1TLh4bC/fz8OngsZuQiYd/eXFiWVlZRTwtKBUPDwz79vLx7evo5uTe29nY1NTOx8O/vru7rqyrqaGel5aQj4GAgH93c3BtbGZgW1dVSjozMTEkIh4WEvr59/Xz7uHc2tbW09HKycbExMPCu7WroZ6bmpeTiomDd3NvbWdgW1FJSUU4LCggHhuZdyHRAAACl0lEQVQ4y32RZVvjQBSFByp0oS2U4u7uLguLLe7uuu7u7u47NAWSdptQ72/cSWcilKd5v9yTM++T3CQghPKRm/XV1fXXNSqgSHnrPqH2j6I4hpQInv39PkWxNiJibEOl2shBbrmCp6GoBpxaKSo6rLaDPGoe51gKmcdf6MfL6JEJzSV02CNUpylE38SraM13yftM7RF6IoFoCh01K1SqPSumIQfImG8i9Z6wwi2rtSknY8gQawZHiIw1DGXMNlutD8jeh4eHP0FYfqHjb8HUzHEZQAEDx93Y4QPH1UXK+orCT8tbRzao4zgDHwKBGak9o0+CEEY9LJSZM4HAPX7a7QNiV5wCCZOSOGC3d2HRviDcj7/dHX3/RTTmBG8BCYt8+MiyNWTJVAiT+Yf+fYxME1mxhmXf4tjFsgXBUIK2K8bdKQhHcVpk2dsAU+D3Pw+GdxA+Jd0ahG04PfP7C0gZ53CcCIYYCPMAIRleqAiGEw5HHOnWZeKyJFYdE5d8vsFgmIJQjwZZ9ypOgz7fEik7vd5c/BUhrDKJ7x+DU67X24mT1uM5ZxbfNWWN/yR6CGEJ7sxnPR58H5vNpgUYUxQSUidH+f/zBhC0SPiCxV4gsJoECTFApNdme8RPt1srlVv9UbzWlgcktG73fX66XI1Ahilvam4VyGl0uTL52c4w2UCBLIa5ssmHFYZh4sN7v9FxPo7dFstJY3bWh/VQp2g6azq/HZ2S6/hdC+buV7lmvGYhbArVyq5ApuSpxdIolXHpT8azh3UHBweiqUYX59Xj6d1pRSCUsmF0SOp8FNXbIBwvnM4OnC47nWqgQCJNG+NLS7ff03SCWUlMp2m6MiGhEo00oERZyz+CrhQom687dImJupa00H/1H82P+Mv2aDhQAAAAAElFTkSuQmCC"
                        alt=""><span>功能设置</span></div>
                <div class="person-list-p-right"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
                
            </div>
            <div class="person-list-p" @click="go('/password')">
                <div class="person-list-p-left"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAACDVBMVEUAAABIZKRQfbZJZqduhbpJZaZkfLQwg/9yiLtcdq9KZqUwhP8vg/9Qa6lthLlNaKZgerIygP9xhLtfda1xh7tyiLwwg/8vg/8wg/8wgv9xh7tvhrpPa6hqgrhqgLdrg7hMaKZherIwg/9tgrhZc64vgv9uhbkwhP8wg/9wiLtvir1KY6Uwg/9xh7swg/9GY6NXcaxHY6RSbKlGY6NMZqZmfrZOaahQaqlyibxIZKUwg/9pgbdqg7dxiLtgeLEwhP9XcK1sg7hMaKZkfLVKZKZMaKYwg/9Vb6ted7FOaahvhblJZaQwg/9IZKRuhLlMZqUwhP8wg/9qg7hSbqxOaKYvgv9MaKdWcKxXcKtfd7Evg/9nf7cwg/8vg/9me7RIZaRqgLgwgv9uiLtQbKowg/9hebNhebJuhbkwg/8wg/9LZqZvhrpogLYwg/9rgrhGY6NRbKlGY6NOaqdZcq4wg/9rgrdTb6plfrROaqcwg/9kfLMwg/9thbkwg/9ada5bdK5vhbpLZqdMZqZzirwxgv9Ycq4xg/9xiLpsg7ZXcq0wgv9MaKVie7NrgrhQbKhOZ6ZNaaRRaKhTbKZogLdEZqEvhP8wg/9thLhrgrhLZqZOaadNaKZHY6RuhbpxiLtpgLdje7RVcKxyiLtcda9Yca1SbKlQa6lwhrpnfrVlfbRhebJgebFed7FadK5TbquF1h/vAAAAlnRSTlMA/gYjqZxw/Oe4s5iThF1TLh4bC/fz8OngsZuQiYd/eXFiWVlZRTwtKBUPDwz79vLx7evo5uTe29nY1NTOx8O/vru7rqyrqaGel5aQj4GAgH93c3BtbGZgW1dVSjozMTEkIh4WEvr59/Xz7uHc2tbW09HKycbExMPCu7WroZ6bmpeTiomDd3NvbWdgW1FJSUU4LCggHhuZdyHRAAACl0lEQVQ4y32RZVvjQBSFByp0oS2U4u7uLguLLe7uuu7u7u47NAWSdptQ72/cSWcilKd5v9yTM++T3CQghPKRm/XV1fXXNSqgSHnrPqH2j6I4hpQInv39PkWxNiJibEOl2shBbrmCp6GoBpxaKSo6rLaDPGoe51gKmcdf6MfL6JEJzSV02CNUpylE38SraM13yftM7RF6IoFoCh01K1SqPSumIQfImG8i9Z6wwi2rtSknY8gQawZHiIw1DGXMNlutD8jeh4eHP0FYfqHjb8HUzHEZQAEDx93Y4QPH1UXK+orCT8tbRzao4zgDHwKBGak9o0+CEEY9LJSZM4HAPX7a7QNiV5wCCZOSOGC3d2HRviDcj7/dHX3/RTTmBG8BCYt8+MiyNWTJVAiT+Yf+fYxME1mxhmXf4tjFsgXBUIK2K8bdKQhHcVpk2dsAU+D3Pw+GdxA+Jd0ahG04PfP7C0gZ53CcCIYYCPMAIRleqAiGEw5HHOnWZeKyJFYdE5d8vsFgmIJQjwZZ9ypOgz7fEik7vd5c/BUhrDKJ7x+DU67X24mT1uM5ZxbfNWWN/yR6CGEJ7sxnPR58H5vNpgUYUxQSUidH+f/zBhC0SPiCxV4gsJoECTFApNdme8RPt1srlVv9UbzWlgcktG73fX66XI1Ahilvam4VyGl0uTL52c4w2UCBLIa5ssmHFYZh4sN7v9FxPo7dFstJY3bWh/VQp2g6azq/HZ2S6/hdC+buV7lmvGYhbArVyq5ApuSpxdIolXHpT8azh3UHBweiqUYX59Xj6d1pRSCUsmF0SOp8FNXbIBwvnM4OnC47nWqgQCJNG+NLS7ff03SCWUlMp2m6MiGhEo00oERZyz+CrhQom687dImJupa00H/1H82P+Mv2aDhQAAAAAElFTkSuQmCC"
                        alt=""><span>修改登录密码</span></div>
                <div class="person-list-p-right"><img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
                </div>
                
            </div>
        </div>
    </div>
    <div style="height: 150px; width: 100%;"></div>
</div>

  </div>
</template>
<script>
export default {
    name: 'mine',
    data() {
      return {
        activitylistList: [],
        bfNum: 0,
        vipLis: [],
      };
    },
    created() {
      let that = this;
      that.activitylist();
      that.uservip();
    },
    methods: {
      go(s){
        this.$router.push(s)
      },
      onchangemd(e) {
        let that = this;
  
        console.log(e.target.files); //这个就是选中文件信息
        let formdata = new FormData();
        Array.from(e.target.files).map(item => {
          console.log(item);
          formdata.append('file', item); //将每一个文件图片都加进formdata
        });
        //  axios.post("接口地址", formdata).then(res => { console.log(res) })
        that.$parent.showLoading();
  
        that.$apiFun.post('/api/uploadimg', formdata).then(res => {
          that.$parent.hideLoading();
  
          that.$parent.getUserInfoShowLoding();
        });
      },
      uservip() {
        let that = this;
        that.$parent.showLoading();
        that.$apiFun
          .post('/api/uservip', {})
          .then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.vipLis = res.data;
              that.getbfNum();
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
      },
      getbfNum() {
        let that = this;
        let num = 0; //当前vip充值钱
        let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
        that.vipLis.forEach((el, index) => {
          console.log();
          if (index == vip) {
            num = el.recharge * 1;
          }
        });
        let userMey = that.$store.state.userInfo.paysum * 1;
        let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
        that.bfNum = bfNum > 100 ? 100 : bfNum;
        console.log(111);
      },
      transall() {
        let that = this;
        that.$parent.showLoading();
        that.$apiFun
          .post('/api/transall', {})
          .then(res => {
            that.$parent.showTost(0, res.message);
            that.$parent.getUserInfoShowLoding();
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
      },
      activitylist() {
        let that = this;
        let info = that.actType == '' ? {} : { type: that.actType };
        that.$parent.showLoading();
        that.$apiFun.post('/api/activitylist', info).then(res => {
          console.log(res);
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.activitylistList = res.data.data;
          }
          that.$parent.hideLoading();
        });
      },
    },
    mounted() {
      let that = this;
    },
    updated() {
      let that = this;
    },
    beforeDestroy() {},
  };
</script>
<style lang="scss" scoped>
.person .topContent .topArea {
  height:4.98667rem;
  background-size:100% 100%
}
.person .topContent .topArea .head_area {
  height:1.33333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  padding-left:.48rem;
  padding-right:.48rem;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  box-sizing:border-box;
  z-index:1
}
.person .topContent .topArea .head_area .leftImg {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:left
}
.person .topContent .topArea .head_area .leftImg .top_back {
  width:.85333rem;
  height:.85333rem
}
.person .topContent .topArea .head_area .head_text {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#fff;
  text-align:center
}
.person .topContent .topArea .head_area .right_menu {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:700;
  color:#1d2548;
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:right
}
.person .topContent .topArea .head_area .right_menu .right_menu_img {
  width:.58667rem;
  height:.58667rem
}
.person .topContent .topArea .part1 {
  padding-left:.48rem;
  padding-right:.4rem;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  margin-top:1.33333rem;
  width:calc(100vw - .8rem)
}
.person .topContent .topArea .part1,
.person .topContent .topArea .part1 .avatarBox {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  z-index:999
}
.person .topContent .topArea .part1 .avatarBox {
  width:1.68rem;
  height:1.68rem;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  background-color:#fff;
  border-radius:50%
}
.person .topContent .topArea .part1 .avatarBox .avatar {
  width:1.6rem;
  height:1.6rem;
  border-radius:50%
}
.person .topContent .topArea .part1 .signature {
  font-size:.29333rem;
  font-family:PingFang SC;
  font-weight:500;
  transform: translate(-196px);
  margin-top: -20px;
  color:#fff
}
.person .topContent .topArea .hudu {
  height:1.17333rem;
  background-size:100% 100%;
  margin-top:-.53333rem;
  z-index:8
}
.person .topContent .topArea .part2 {
  margin-top:-.48rem;
  padding-left:.48rem;
  padding-right:.42667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .topContent .topArea .part2 .nickname {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#0b1028
}
.person .topContent .topArea .part2 .rightSpan {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  height:.58667rem;
  border-radius:.10667rem;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  padding-left:.24rem;
  padding-right:.24rem;
  margin-left:.06667rem;
  margin-right:.06667rem;
  font-size:.29333rem;
  font-family:DINOT;
  font-weight:500;
  color:#fcfcfc
}
.person .topContent .actionList,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
person .topContent .actionList1,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  transform: translateX(-184px);
  font-size: 108%;
  margin-top: -52px;
  align-items:center
}
.person .topContent .actionList {
  width:9.2rem;
  height:1.16rem;
  border-radius:.26667rem;
  margin:0 auto;
  transform: translateY(-1px);
  margin-top:.53333rem
}
.person .topContent .actionList1,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .topContent .actionList1 {
  background-image: url(https://wswds3.shranshen.com/h5_static/wd/img/personBg.31426604.png);
    
    background-size: 100% 100%;
    left: 100px;
    transform: translateX(0%);
    width: 10.2rem;
    margin-top: -59px;
}
.person .topContent .actionList1 {
  width:10.2rem;
  height:3.16rem;
  border-radius:.26667rem;
  margin:0 auto;
  margin-top:-53px;
  
}
.person .topContent .actionList .actionicon {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;

  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1
}
.person .topContent .actionList1 .actionicon1 {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1
}
.person .topContent .actionList .actionicon img {
  width:1.12667rem;
  height:1.20667rem;
}
.person .topContent .actionList1 .actionicon1 img {
  transform: translateY(19px);
  height:1.04rem
}

.person .topContent .actionList .actionicon .title {
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#0b1028
}
.person .topContent .actionList1 .actionicon1 .title {
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#0b1028
}
.person .topContent .topAmount {
  width:9.2rem;
  position: relative;
    z-index: 1;
  height:0.9rem;
  
  border-radius:.26667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  margin:0 auto;
  margin-top:.29333rem
  
  
  
}
.person .topContent .topAmount .AmountLeft {
  height:1.22667rem;
  margin-left:.42667rem;
  
  color:#ffffff;
  line-height:1.22667rem;
  
  margin-top: -4vmin;
  
}
.person .topContent .topAmount .AmountLeft img {
  width:.58667rem;
  //height:.58667rem;
  position:absolute;
 
  margin-top: 3vmin;
}
.person .topContent .topAmount .AmountLeft .AmountName {
  font-size: 140%;
  
}
.person .topContent .topAmount .AmountRight {
  
  margin-top: -4vmin;
}
.person .topContent .topAmount .AmountRight .AmountMoney {
  color:#ffffff;
  font-size:.48rem;
  font-weight:500;
  line-height:1.22667rem
}
.person .topContent .topAmount .AmountRight img {
  width:.37333rem;
  height:.37333rem;
  margin-left:.4rem;
  margin-top:.42667rem
}
.person .userInfo {
  width:100%;
  background:#fff;
  padding:.4rem .4rem .53333rem .4rem;
  box-sizing:border-box;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  border-bottom:.02667rem solid #d7ddeb
}
.person .userInfo .info_left {
  width:1.6rem;
  height:1.6rem;
  border-radius:50%;
  overflow:hidden
}
.person .userInfo .info_left img {
  width:100%
}
.person .userInfo .info_content {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:100%;
  padding-left:.4rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column
}
.nickname {
  opacity: 0 !important;
}
.person .userInfo .info_content .lable {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex
}
.person .userInfo .info_content .lable>span {
  height:.58667rem;
  line-height:.58667rem;
  display:inline-block;
  background-color:#f2f4fd;
  border-radius:.10667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  margin-right:.16rem;
  color:#5b6897;
  font-size:.29333rem;
  padding-left:.24rem;
  padding-right:.24rem
}
.person .userInfo .info_content>:last-child {
  color:#6072a5
}
.person .userInfo>img {
  width:.16rem;
  height:.26667rem
}
.person .level_box {
  width:100%;
  height:1.33333rem;
  margin-top:.26667rem;
  padding:0 .4rem;
  box-sizing:border-box;
  background:#fff;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .level_box>:first-child {
  width:.58667rem;
  height:.58667rem;
  margin-right:.29333rem
}
.person .level_box span {
  font-size:.42667rem;
  font-family:PingFang SC;
  font-weight:500
}
.person .level_box .level_img {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:right;
  padding-right:.26667rem
}
.person .level_box .level_img img {
  width:.4rem;
  height:.4rem;
  margin:0 .02667rem
}
.person .level_box>:last-child {
  width:.16rem;
  height:.26667rem
}
.person #hyjhtre {
  display:inline-block;
  width:.42667rem;
  height:.42667rem;
  float:none;
  margin-left:.4rem;
  margin-top:-.05333rem;
  vertical-align:middle;
  margin-right:.36rem
}
.person .person-head {
  height:5.65333rem;
  width:100%;
  background-size:cover;
  text-align:center;
  position:relative
}
.person .person-head .leftboxsdiv {
  float:left;
  width:100%;
  height:1.6rem;
  position:absolute;
  left:0;
  bottom:-.8rem;
  z-index:200
}
.person .person-head .leftboxsdiv .person-head-img {
  float:left;
  width:1.6rem;
  height:1.6rem;
  border-radius:50%;
  margin-left:.26667rem
}
.person .person-head .leftboxsdiv .rightdivcont {
  float:left;
  width:6.66667rem;
  margin-left:.26667rem
}
.person .person-head .leftboxsdiv .rightdivcont .person-nickname {
  height:.8rem;
  font-size:.42667rem;
  font-weight:600;
  color:#fff
}
.person .person-head .leftboxsdiv .rightdivcont .person-nickname,
.person .person-head .leftboxsdiv .rightdivcont .person-vip {
  float:left;
  width:100%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .person-head .leftboxsdiv .rightdivcont .person-vip {
  height:.64rem;
  font-size:.32rem;
  color:#999
}
.person .person-head .leftboxsdiv .rightdivcont .person-vip img {
  height:.42667rem;
  width:auto;
  margin-right:.26667rem
}
.person .person-list-p {
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  font-size:.32rem;
  margin:0 0;
  height:1.33333rem;
  padding:0 .4rem;
  font-size:.42667rem;
  font-family:PingFang SC;
  font-weight:500;
  transform: translateY(9px);
  background:#fff
}
.person .person-list-p,
.person .person-list-p .person-list-p-left {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .person-list-p .person-list-p-left>:first-child {
  width:.58667rem;
  height:.58667rem
}
.person .person-list-p .person-list-p-left span {
  margin-left:.4rem
}
.person .person-list-p .person-list-p-left span .vipNum {
  color:red
}
.person .person-list-p .person-list-p-right {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end
}
.person .person-list-p .person-list-p-right>:last-child {
  width:.16rem;
  height:.26667rem
}
.person .person-list-p .person-list-p-right .textRight {
  text-align:right;
  margin:0;
  color:#5d6b9d;
  font-size:.37333rem;
  font-weight:Medium;
  margin-right:.37333rem
}
.person .person-icon {
  width:.58667rem;
  height:.58667rem;
  display:inline-block;
  background-size:cover;
  background-position-y:0;
  position:relative;
  top:.08rem;
  margin:0 .4rem
}
.person .porcessct {
  width:5.33333rem;
  height:.34667rem;
  background:#fff;
  border-radius:.17333rem;
  margin:.26667rem 0 0 2.34667rem;
  overflow:hidden;
  float:left;
  position:relative
}
.person .porcessct .datadiv {
  width:100%;
  height:100%;
  position:absolute;
  z-index:300;
  top:0;
  left:0;
  font-size:.32rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-transform:scale(.67);
  -ms-transform:scale(.67);
  transform:scale(.67)
}
.person .porcessct .procees {
  width:20%;
  height:.34667rem;
  background:#62b6f8;
  position:absolute;
  top:0;
  left:0;
  z-index:200
}
.person .right_notice {
  position:fixed;
  top:4.8rem;
  right:0;
  z-index:300
}
.person .right_notice .notice_item {
  min-width:4rem;
  height:1.33333rem;
  padding:0 .26667rem;
  margin-bottom:.26667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  background:#fff;
  box-shadow:0 0 .26667rem 0 rgba(45,55,99,.25);
  border-radius:.66667rem 0 0 .66667rem;
  -webkit-transition:all .3s linear;
  transition:all .3s linear
}
.person .right_notice .notice_item>:first-child {
  width:.16rem;
  height:.26667rem
}
.person .right_notice .notice_item>:nth-child(2) {
  width:1.04rem;
  height:1.04rem;
  margin:.26667rem
}
.person .right_notice .notice_item>:nth-child(3) {
  color:#1d2548;
  font-size:.32rem;
  font-weight:700
}
.person .hiddenRight {
  -webkit-transform:translateX(0)!important;
  -ms-transform:translateX(0)!important;
  transform:translateX(0)!important
}
.person .hiddenRight>:first-child {
  -webkit-transform:rotate(0deg)!important;
  -ms-transform:rotate(0deg)!important;
  transform:rotate(0deg)!important
}
.right_notice {
  position:fixed;
  top:4.8rem;
  right:0;
  z-index:300
}
.right_notice .notice_item {
  min-width:4rem;
  height:1.33333rem;
  padding:0 .26667rem;
  margin-bottom:.26667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  background:#fff;
  box-shadow:0 0 .26667rem 0 rgba(45,55,99,.25);
  border-radius:.66667rem 0 0 .66667rem;
  -webkit-transform:translateX(2.58667rem);
  -ms-transform:translateX(2.58667rem);
  transform:translateX(2.58667rem);
  -webkit-transition:all .3s linear;
  transition:all .3s linear
}
.right_notice .notice_item>:first-child {
  width:.16rem;
  height:.26667rem;
  -webkit-transform:rotate(180deg);
  -ms-transform:rotate(180deg);
  transform:rotate(180deg)
}
.right_notice .notice_item>:nth-child(2) {
  width:1.04rem;
  height:1.04rem;
  margin:.26667rem
}
.right_notice .notice_item>:nth-child(3) {
  color:#1d2548;
  font-size:.32rem;
  font-weight:700
}
.right_notice .notice_item .cutDown {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  padding-top:.05333rem
}
.right_notice .notice_item .cutDown .tittleGif {
  width:2.24rem;
  height:.32rem
}
.right_notice .notice_item .cutDown .timeText {
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#007aff;
  margin-top:.10667rem
}
.actionCenter[data-v-7bf83c52] {
  text-align:center
}
.actionCenter .head[data-v-7bf83c52] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  width:100%;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  position:relative;
  background:#fff;
  border-bottom:.02667rem solid #e7eaf3
}
.actionCenter .head[data-v-7bf83c52]>:first-child {
  width:.85333rem;
  height:.85333rem;
  margin-left:.26667rem;
  position:absolute;
  left:0;
  top:.10667rem
}
.actionCenter .head span[data-v-7bf83c52] {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:700;
  color:#1d2548
}
.actionCenter .navslist[data-v-7bf83c52] {
  width:100%;
  background:#fff
}
.actionCenter .navslist[data-v-7bf83c52],
.actionCenter .navslist div[data-v-7bf83c52] {
  height:1.33333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex
}
.actionCenter .navslist div[data-v-7bf83c52] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  color:#2f3242;
  font-size:.37333rem
}
.actionCenter .navslist .divac[data-v-7bf83c52] {
  color:#4f8dfe
}
.actionCenter .action-list[data-v-7bf83c52] {
  width:100%;
  height:calc(100% - 2.50667rem);
  overflow-x:hidden;
  overflow-y:auto
}
.actionCenter .action-list .action-card[data-v-7bf83c52] {
  margin:0 .26667rem;
  padding:.26667rem 0;
  background:#fff;
  border-radius:.13333rem
}
.actionCenter .action-list .action-card img[data-v-7bf83c52] {
  width:8.93333rem;
  height:4.26667rem
}
.actionCenter .action-list .action-card .action-p1[data-v-7bf83c52] {
  font-size:.37333rem;
  color:#2f3242;
  text-indent:.26667rem;
  margin:0 0;
  text-align:left;
  margin-top:.32rem
}
.actionCenter .action-list .action-card .action-p2[data-v-7bf83c52] {
  font-size:.32rem;
  color:#575c73;
  text-indent:.26667rem;
  margin:0 0;
  text-align:left;
  margin-top:.13333rem
}
.regist[data-v-24d6c286] {
  width:100%
}
.hongbaoDetails .botline div[data-v-24d6c286],
.hongbaoDetails .replenishment .botline div[data-v-24d6c286],
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286],
.textctr[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286],
.textrtr[data-v-24d6c286] {
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286],
.textlt[data-v-24d6c286],
.textrtr[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.textlt[data-v-24d6c286] {
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end
}
.hongbaoDetails[data-v-24d6c286] {
  height:100%;
  background-color:#fff;
  background-image:url(/static/img/zcdl_bj.dd3e65d0.png);
  background-repeat:no-repeat;
  background-size:100% auto;
  float:left;
  width:100%;
  box-sizing:border-box
}
.hongbaoDetails .gbline[data-v-24d6c286] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:1.06667rem
}
.hongbaoDetails .loglines[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  width:100%;
  height:2.13333rem;
  margin-top:1.73333rem;
  margin-bottom:1.12rem
}
.hongbaoDetails .loglines img[data-v-24d6c286] {
  width:4rem
}
.hongbaoDetails .lginner[data-v-24d6c286] {
  float:left;
  width:100%;
  box-sizing:border-box;
  padding:0 1.06667rem
}
.hongbaoDetails .lginner .gbline[data-v-24d6c286] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:.53333rem;
  height:.53333rem
}
.hongbaoDetails .getBack[data-v-24d6c286] {
  font-size:.4rem;
  text-align:center
}
.hongbaoDetails .sbac[data-v-24d6c286] {
  opacity:1
}
.hongbaoDetails .botline[data-v-24d6c286] {
  float:left;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.hongbaoDetails .botline div[data-v-24d6c286] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.hongbaoDetails .replenishment[data-v-24d6c286] {
  padding:0 1.01333rem
}
.hongbaoDetails .replenishment .inputline[data-v-24d6c286]:after {
  content:".";
  height:0;
  visibility:hidden;
  display:block;
  clear:both
}
.hongbaoDetails .replenishment .inputline[data-v-24d6c286] {
  float:left;
  width:100%;
  height:1.2rem;
  background:#fff;
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.26667rem;
  z-index:3;
  position:relative
}
.hongbaoDetails .replenishment .inputline input[data-v-24d6c286] {
  width:6.93333rem;
  padding-left:.4rem;
  float:left;
  color:#1d2548;
  text-align:left;
  line-height:1.12rem;
  font-size:.37333rem;
  border:none;
  outline:none;
  left:.74667rem;
  top:.05333rem;
  position:absolute;
  z-index:2;
  background:#fff
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286] {
  width:50%;
  height:1.2rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  left:1.12rem;
  padding-left:0
}
.hongbaoDetails .replenishment .inputline .eye[data-v-24d6c286] {
  float:right;
  width:.42667rem;
  height:.21333rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  position:absolute;
  z-index:3;
  right:0
}
.hongbaoDetails .replenishment .inputline .iconImg[data-v-24d6c286] {
  float:left;
  width:.34667rem;
  height:.42667rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  margin-left:.4rem;
  position:absolute;
  z-index:3;
  left:0
}
.hongbaoDetails .replenishment .inputline .yzm[data-v-24d6c286] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286] {
  float:left;
  height:1.2rem;
  color:#fff;
  margin-top:.8rem;
  font-size:.45333rem;
  font-weight:700;
  opacity:.7
}
.hongbaoDetails .replenishment .sumbtns .van-button--block[data-v-24d6c286],
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286] {
  width:100%;
  background-color:#237bff;
  border-radius:.21333rem
}
.hongbaoDetails .replenishment .sbac[data-v-24d6c286] {
  opacity:1
}
.hongbaoDetails .replenishment .botline[data-v-24d6c286] {
  float:left;
  width:100%;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.hongbaoDetails .replenishment .botline div[data-v-24d6c286] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.Login-window[data-v-a2119fda] {
  width:100%;
  height:100%
}
.loginwindow .LoginSquare .botline div[data-v-a2119fda],
.loginwindow .LoginSquare .confirm .sumbtns[data-v-a2119fda],
.textctr[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .inputline div[data-v-a2119fda],
.textrtr[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines>div[data-v-a2119fda]:nth-child(2),
.textlt[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow[data-v-a2119fda] {
  width:100%;
  height:100%;
  background-color:#fff;
  background-image:url(/static/img/topss1.dd3e65d0.png);
  background-repeat:no-repeat;
  background-size:100% auto
}
.loginwindow .lginner[data-v-a2119fda] {
  float:left;
  width:100%;
  box-sizing:border-box;
  padding:0 1.06667rem
}
.loginwindow .lginner .gbline[data-v-a2119fda] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:1.06667rem
}
.loginwindow .loglines[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  width:100%;
  height:2.13333rem;
  margin-top:1.73333rem;
  margin-bottom:1.12rem
}
.loginwindow .loglines img[data-v-a2119fda] {
  width:3.49333rem
}
.loginwindow .loglines div[data-v-a2119fda] {
  width:5.38667rem;
  height:1.38667rem;
  font-size:.61333rem;
  font-weight:700;
  margin-top:.10667rem;
  float:left;
  line-height:.72rem;
  margin-left:.56rem
}
.loginwindow .LoginSquare .inputline[data-v-a2119fda] {
  float:left;
  width:100%;
  height:1.2rem;
  background:#fff;
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.26667rem;
  position:relative
}
.loginwindow .LoginSquare .inputline input[data-v-a2119fda] {
  width:6.93333rem;
  height:1.2rem;
  padding-left:.4rem;
  float:left;
  color:#1d2548;
  text-align:left;
  height:45px;
  font-size:.37333rem;
  border:none;
  outline:none;
  left:0;
  top:0;
  position:absolute;
  z-index:2;
  background:#fff;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline div[data-v-a2119fda] {
  width:50%;
  height:1.12rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  right:0;
  background-color:#fff;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline .eye[data-v-a2119fda] {
  float:right;
  width:.42667rem;
  height:.21333rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  position:absolute;
  z-index:3;
  right:0
}
.loginwindow .LoginSquare .inputline .yzm[data-v-a2119fda] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.loginwindow .LoginSquare .confirm[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center
}
.loginwindow .LoginSquare .confirm .sumbtns[data-v-a2119fda] {
  float:left;
  height:1.2rem;
  color:#fff;
  width:5.33333rem;
  background-color:#237bff;
  border-radius:.21333rem;
  margin-top:.8rem;
  font-size:.45333rem;
  font-weight:700;
  opacity:.7
}
.loginwindow .LoginSquare .confirm .sbac[data-v-a2119fda] {
  opacity:1
}
.loginwindow .LoginSquare .botline[data-v-a2119fda] {
  float:left;
  width:100%;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.loginwindow .LoginSquare .botline div[data-v-a2119fda] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.loginwindow .LoginSquare .oplines[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  width:100%;
  padding-top:.77333rem;
  color:#1d2548;
  font-size:.4rem;
  font-family:PingFang SC;
  font-weight:500
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon[data-v-a2119fda] {
  font-size:.34667rem;
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-icon[data-v-a2119fda] {
  width:.34667rem;
  height:.34667rem;
  border-radius:.08rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__label[data-v-a2119fda] {
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon--checked .van-icon[data-v-a2119fda] {
  background-color:#1989fa
}
.loginwindow .LoginSquare .oplines .ltbox[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines .ltbox>img[data-v-a2119fda] {
  margin-right:.08rem;
  width:.85333rem;
  height:.48rem
}
.topIndex[data-v-4f04d936] {
  z-index:999!important
}
.index-container[data-v-4f04d936] {
  max-width:10rem;
  margin:0 auto
}
.index-container .spgifuss[data-v-4f04d936] {
  position:fixed;
  bottom:1.7rem;
  right:.1rem;
  width:1.5rem;
  height:1.5rem
}
.index-container .hbpopclass[data-v-4f04d936] {
  float:left;
  width:100%;
  height:100%;
  background:transparent;
  z-index:200
}
.index-container .hbpopclass .hbcontentsl[data-v-4f04d936] {
  width:9.86667rem;
  height:12.56rem;
  background:url(/static/img/bgimg.a6fc96be.png) no-repeat;
  background-size:100% 100%;
  margin:0 auto;
  position:relative;
  top:50%;
  -webkit-transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  transform:translateY(-50%)
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont[data-v-4f04d936] {
  float:left;
  width:5.52rem;
  height:7.33333rem;
  margin:2.93333rem 0 0 2.13333rem;
  overflow-y:scroll
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner[data-v-4f04d936] {
  float:left;
  width:100%
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshi[data-v-4f04d936] {
  float:left;
  width:5.52rem;
  height:2.18667rem;
  margin-top:.08rem
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshiylq[data-v-4f04d936] {
  float:left;
  width:5.46667rem;
  height:2.18667rem;
  background:url(/static/img/ylq.9efab72b.png) no-repeat;
  background-size:100% 100%;
  margin-top:.08rem
}
.index-container .hbpopclass .hbcontentsl .xxbtn[data-v-4f04d936] {
  float:left;
  width:1.28rem;
  height:1.28rem;
  margin-left:4.26667rem
}
.index-container .hbpopclass .dkhbsssss[data-v-4f04d936] {
  width:7.17333rem;
  height:8.45333rem;
  position:relative;
  top:50%;
  margin:0 auto;
  -webkit-transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  transform:translateY(-50%);
  background:url(/static/img/hbimg.a1d1f8b4.png) no-repeat;
  background-size:100% 100%
}
.index-container .hbpopclass .dkhbsssss .icoimg[data-v-4f04d936] {
  float:left;
  width:.85333rem;
  height:.85333rem;
  margin:1.12rem 0 0 5.22667rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont[data-v-4f04d936] {
  float:left;
  width:100%;
  margin-top:1.17333rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-4f04d936] {
  height:.32rem;
  font-size:.32rem;
  color:#fff
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-4f04d936],
.index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-4f04d936] {
  float:left;
  width:100%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-4f04d936] {
  height:.77333rem;
  font-size:1.01333rem;
  font-weight:600;
  color:#ffe9ac;
  margin-top:.24rem;
  margin-bottom:.16rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .textcmnetdss[data-v-4f04d936] {
  float:left;
  width:100%;
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#fff;
  line-height:.42667rem;
  text-align:center;
  margin-top:.66667rem
}
.index-container .hbpopclass .dkhbsssss .hbbbtn[data-v-4f04d936] {
  float:left;
  position:absolute;
  width:3.33333rem;
  height:1.12rem;
  bottom:1.65333rem;
  left:1.92rem;
  background:url(data:image/png;base64,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) no-repeat;
  background-size:100% 100%
}
.index-container .warpper[data-v-4f04d936] {
  background:#fff
}
.index-container .warpper .bottom-taps[data-v-4f04d936] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  position:fixed;
  height:1.30667rem;
  bottom:0;
  border-top:.02667rem solid #fff;
  box-shadow:0 0 .53333rem 0 rgba(102,118,165,.15);
  width:100%;
  max-width:10rem;
  background:#fff;
  padding-top:.13333rem;
  border-radius:.26667rem .26667rem 0 0
}
.index-container .warpper .bottom-taps .bottom-taps-list[data-v-4f04d936] {
  width:25%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  color:#6b7db2
}
.index-container .warpper .bottom-taps .bottom-taps-list img[data-v-4f04d936] {
  width:.58667rem
}
.index-container .warpper .bottom-taps .bottom-taps-list p[data-v-4f04d936] {
  line-height:.58667rem;
  height:.58667rem;
  margin:0 0
}
.index-container .warpper .bottom-taps .tapsactive[data-v-4f04d936] {
  color:#2385ff
}
.readnums[data-v-4f04d936] {
  margin-right:.26667rem;
  background:#f81b1b;
  padding:.02667rem .13333rem;
  color:#fff;
  border-radius:.26667rem;
  position:absolute;
  margin-left:.26667rem
}
</style>


// WEBPACK FOOTER //
// src/components/mode/mine.vue